import React, { FC } from 'react';

import { Tag } from '@dev/ee-components';
import { FilterContainer, FilterLabel } from '@/components/Campaigns/assets/EventFilter/styledComponents';

interface Props {
    label: string;
    count: number;
}

const CampaignsListFilterItem: FC<Props> = ({ label, count }: Props): JSX.Element => (
    <FilterContainer>
        <FilterLabel>{label}</FilterLabel>
        <Tag label={count} />
    </FilterContainer>
);

export default CampaignsListFilterItem;
